module.exports = __webpack_public_path__ + "static/media/campaignSkeletonXs.f1e01baf.svg";